export const parseMacroData = ({ data }) =>
  Object.fromEntries(
    Object.entries(data).map(([key, value]) => {
      if (value === "true") {
        return [key, true];
      }

      if (value === "false") {
        return [key, false];
      }

      if (!isNaN(value) && value.trim() !== "") {
        return [key, Number(value)];
      }

      return [key, value];
    })
  );

export const parseInputNumber = (event) => {
  let inputValue = event.target.value;

  inputValue = inputValue.replace(/[^0-9]/g, "");

  let numericValue = parseInt(inputValue, 10);

  if (isNaN(numericValue)) {
    numericValue = 0;
  } else if (numericValue < 0) {
    numericValue = 0;
  } else if (numericValue > 99) {
    numericValue = 99;
  }

  return numericValue;
};
